export default "__VITE_ASSET__Bg1Ni55Y__"